import React, { useContext, useEffect, useState } from "react";
import "../../assets/css/--page-aboutus.css";
import ourValuesText from "../../assets/images/our-legacy-and-values.png";
import interior from "../../assets/images/interior.png";
import familyOwnedIcon from "../../assets/images/family-owned-icon.png";
import welcomingSpaceIcon from "../../assets/images/welcoming-space-icon.png";
import qualityMealsIcon from "../../assets/images/quality-meal-icon.png";
import friendlyStaffIcon from "../../assets/images/friendly-staff-icon.png";
import { ValueCard } from "./valueCard";

const values = [
    {
        image: familyOwnedIcon,
        title: "Family-Owned Since 1982"
    },
    {
        image: welcomingSpaceIcon,
        title: "Clean, Welcoming Spaces"
    },
    {
        image: qualityMealsIcon,
        title: "Home-Cooked, Quality Meals"
    },
    {
        image: friendlyStaffIcon,
        title: "Respectful, Friendly Staff"
    }
]

export default function ValuesSection() {

  return (
    <div className="values-section">
        <div className="wrapper">
            <div className="values-layout">
                <div className="header">
                    <img src={ourValuesText} alt="Values" />
                    <h1>A LOCAL STAPLE WITH A BIG HEART</h1>
                </div>
                <div className="values-cards">
                    {values.map((value, index) => (
                        <ValueCard key={index} image={value.image} title={value.title} />
                    ))}
                </div>
                <img className="interior-img" src={interior} alt="Values" />
            </div>
        </div>
    </div>

  );
}
